import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const getProducts = (params) => api.get("/products", { params }).then((r) => r.data);
export const getFacets = () => api.get("/products/facets").then((r) => r.data);
export const getProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const getJournal = (category) => api.get("/journal", { params: { category } }).then((r) => r.data);
export const getJournalPost = (slug) => api.get(`/journal/${slug}`).then((r) => r.data);
export const postReview = (data) => api.post("/reviews", data).then((r) => r.data);
export const subscribeNewsletter = (email, source) => api.post("/newsletter", { email, source }).then((r) => r.data);
export const sendContact = (data) => api.post("/contact", data).then((r) => r.data);
export const checkDiscount = (code) => api.get(`/discount/${code}`).then((r) => r.data);
export const createCheckout = (data) => api.post("/payments/checkout", data).then((r) => r.data);
export const getPaymentStatus = (sid) => api.get(`/payments/status/${sid}`).then((r) => r.data);
export const getOrders = () => api.get("/orders").then((r) => r.data);
export const authMe = () => api.get("/auth/me").then((r) => r.data);
export const authSession = (session_id) => api.post("/auth/session", { session_id }).then((r) => r.data);
export const authLogout = () => api.post("/auth/logout").then((r) => r.data);
